const { createMachine } = require("xstate");
const actions = require("./actions");
const guards = require("./guards");
const services = require("./services");

const CreateActionPlanMachine = createMachine(
  {
    /** @xstate-layout N4IgpgJg5mDOIC5QGMBOYCGAXMBaDyWAlgPYB2uADgDYZkB0RE1YAxAMoAqAggEqcBtAAwBdRKEolYRYuXEgAHolwAmAIwr6ADgAsagJz6AzAFYhJlVrVajAGhABPZUY30dKk1v0B2EzqHeKireAGwAvmH2aJg4+ISkFDR09ATEAG5sAKoACgAi3JwAogD6AEKFfIW8xZwA8gDShQBywmJIIJLSsmTySgiqntreRlqjBjqBJmr2TghqIWpq9N4++n6h-tb6EVHo2HipCVS0DIcZ9NH7AASH5FdJZKwQ5GCMZGkkANavl7G3iScUvFzr8wDd4ncHggiO8SMhsAlWq15J0ZAlespxvQQkI1t5vONTEI1CYZohFjp9PQjEIQjo-CYQnS1IEdiBQXFusdkmcfnscODuvcTqwwKhUCRUPQklgAGaSgC2F35BwhAJ5wL5MTB-2FdGhsPh3SRohRUjRcnafVw9JCyxC+gmlJWKn0tLJc1p3mpox0TJCWk8bpMbI5-25p019FgAFdkMg4LBWABhAAytXYhWR7VR3QxCH0TPoljULn0WhU5gdWg9OiMRmpTNCnhclICOlDKs5RweQPSrzFEtQrF4hU4vAAmtmJOa81blCshPRDBN6759CojPoPeWqVZC4sRiETCsQ5F2V3w73efRB5KU+nM9OOrP0fP+sYqaZP4v64fay4yzeEIRjeH6GiliSnbat25ARn2RDnLAYAsPEZBQFc6DSBAYBkAmADksBXC8VzfA4rC1E0JSNBOxSZqmhTJkUuTPrmb6gNaOiUss6y+CozqMuYHo2JoejHp4figUYx7QfssHqpG-bRihYBoRhWFMLhBFESRZEpqOBRZqaOavpaHHKJWSwboExh+gsKg4iEwkLNSoFaMB1YaLosl-Gq8E3shqHEOhmFwJpeFgIRxFkGCencKU3BNLklHFKOACKmSFFwhQscZM5dOxiiIH6y7SUI5U2LaZhqDownmG4fomIyOhaOY8xGD5qpcteUaBapwXqWFOERVFulgORaYZkZbT5RaPTvrgn7UiYjqbqBdKbB6AbegeXGBCBuI2J18n+VGyDkLKRCoAqNwAEZ0M8jzJolyaFKmxTxYlyUtHlL4FWZRUIA69AkluoTAfxLimDuQiaOsZhrBuOKhMdV6Aje51kJd113Q95CsJ9SWUaxpnzeZnpWMsNXmLotKWIEAENtJITNjYNVuloqN+T1SkwjI9CymAWDIAAFoKCR6mQRFYCQVy3WCoIQE8LxvB83zKjBaMarzZD84Lwti7qDzS7L8tXIrBofEaiKiCT-1k4DuBGPS2jOyErq6JulIeiYphU74NV1is+gGFz3Xo1GfNYALQui+LkInCbcsKyqSuPa8MJq1qcla4piEZ7r0f63HRuJ1cMvJ+bqeW3CCLkEiagzX9c35mt9AWJSK3mCMgaWD7ftNoYQgta1hYqGHPYRzreux4baqS0nZuK6K4qStKtByoqGs59zU-528M8G-HZAL+Xpsp9qEA19b9e279bEA9awHenTnggeopjqMJDbu74q7Ow5Jk49zxhl3trfeUdbyr2HKOccU576k3zLgBYdpGQbmMMMFkdkfZqCXCyWG7tXRgTWO5CecEeYQMLlAocD4pp2xbgtJa353Brg2sSD0pYtDLghm6KGZhxJkIUghc4GBqDUFPqIvYEAHBV0vrQp8CD7b5lpu3RY6CNBcRAjWRwxV6yNhZroaqZhhiCNOtPaOd4pSi1Up8K4ljy4OEoGwehc5ya4GGFSTRWgQjMyasPbRswAEgxGMBQsKwFilg7CAy8YC87nEgZYi4IsbF2OgQ4pxrABCNzNEohaq4QYBlpLSP0rVFjeA9EEzhoSWYHkiREc8ZASA4XgO0UB4c6A5IYW48s3pmFrQ2JtHR-Qpg-0Kd4Kw+0Nyc2iZrWJjBmBgE6a4x2pZNCbnKsEUYhZAz4g9DaBy1J6Q1S8tYGwgZTEUIyEswq1pRgNi8T4pkfiWp7JDvQYkFYFgbgsCMCwFy94ghVMfSW1zH4WSEFwiYBCmr2RZE5IZhY7QBEsD4jZxz-ngKQnGBMsAWmzWWdaGq3o9BNXxLiZqYEAnkj0EuECx55jeMMAScIMyd7tLiQOaBoKHZPwrDxDwQQVg0hbBwow-EQbBFpAsfEGg6QYo5cpIKMJBrYS0pFHSMVSLjW5UgoIOhiwsjXPMNYm5dlDO2tiV00lHTuQ7tsVlvl2XCJ+BdK6N0MD3TII9HV75nb6o8CSoIphjyujqiYEGNU-DuF9mYes8rnUHywD6txNhw0PN8WYF5QynbYjWKYGyfhAw2vjTeSBxc55CmNmfSuitk2O0ldSWGjoSSjArMEeFsxDBuEpf6Rq-gKwlsjlQyxdbeXEv7Y88S-iOGOmCStLw5Utwsm8g6rqk9MWvFEeIqtkjMDSNkfsCAo7EAuG9EAz+1gHT0nKea9ylrjBXttfxe1uxZlOtLcO6BSSUn2KwI4xZJlcluOGJoAIuCrCAJJbVIZlglzuyajYCGQRh6DvMdQteBAcVEWGkQSAx7+gEnuVMYI5YJhBBJLWECIN3JbDUR4PNqHKH80SchVAGRUCpKHPhm0dJu2GEWDGkJVKED+AbNYAkXg6MrV9vUsIQA */
    id: "create-action-plan",
    predictableActionArguments: true,
    context: {
      authentication: {
        token: null,
      },
      qmsToolApiUrl: null,
      actionPlansToBeCreated: [],
    },
    states: {
      idle: {
        on: {
          START: {
            target: "active",
            cond: "validStartRequest",
            actions: [
              "saveStartRequest",
              "unflagChanges",
              "resetCreateRequest",
            ],
          },
        },
      },

      active: {
        states: {
          "create action plan": {
            invoke: {
              src: "createActionPlan",

              onDone: {
                target: "success",
                actions: ["saveActionPlan", "flagChanges"],
              },

              onError: "error",
            },
          },

          success: {
            on: {
              CLOSE: "#create-action-plan.idle",
            },
          },

          error: {
            on: {
              RETRY: "create action plan",
              CLOSE: "#create-action-plan.idle",
            },
          },

          "selecting residence's one key": {
            on: {
              ONE_KEY_SELECTED: {
                target: "selecting residence's one key",
                internal: true,
                actions: "saveOneKey",
              },

              CREATE: {
                target: "create action plan",
                cond: "validOneKey",
              },
              ABANDON_REQUESTED: "confirm abandon",
              CLOSE: "#create-action-plan.idle",
            },
          },

          "confirm abandon": {
            on: {
              CANCEL_ABANDON: "selecting residence's one key",
              ABANDON: "#create-action-plan.idle",
            },
          },

          init: {
            states: {
              "fetch action plans to be created": {
                description: `Fetch the action plans that can be created : /action-plans/to-be-created`,

                invoke: {
                  src: "fetchActionPlansToBeCreated",

                  onDone: [
                    {
                      target:
                        "#create-action-plan.active.selecting residence's one key",

                      cond: "userCanAddANewActionPlan",
                      actions: "saveActionPlansToBeCreated",
                    },
                    "#create-action-plan.active.all plans already created",
                  ],

                  onError: {
                    target: "error",
                    actions: "saveError",
                  },
                },
              },

              error: {
                on: {
                  RETRY: "fetch action plans to be created",
                  CLOSE: "#create-action-plan.idle",
                },

                states: {
                  "check error type": {
                    always: [
                      {
                        target: "access denied",
                        cond: "accessDeniedError",
                      },
                      "server error",
                    ],
                  },

                  "access denied": {},
                  "server error": {},
                },

                initial: "check error type",
              },
            },

            initial: "fetch action plans to be created",
          },

          "all plans already created": {
            on: {
              CLOSE: "#create-action-plan.idle",
            },
          },
        },

        initial: "init",

        on: {
          UPDATE_BEARER_TOKEN: {
            target: "active",
            internal: true,
            cond: "validToken",
            actions: "saveToken",
          },
        },
      },
    },

    initial: "idle",
  },
  {
    actions: actions,
    guards: guards,
    services: services,
  },
);

export { CreateActionPlanMachine };
